import { render, staticRenderFns } from "./DefaultClient.vue?vue&type=template&id=073dcc86&"
import script from "./DefaultClient.vue?vue&type=script&lang=js&"
export * from "./DefaultClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports